import { TFrameEvent, TFrameLabelPayload, TFrameSizePayload } from './types'

export const publishContentSize = (payload: TFrameSizePayload): TFrameEvent => {
    return { event: 'frame', userInteraction: false, ...payload }
}

export const userVotedEvent = (payload: TFrameLabelPayload): TFrameEvent => {
    return { event: 'vote', userInteraction: true, ...payload }
}

export const errorEvent = (): TFrameEvent => {
    return { event: 'error', userInteraction: false }
}

export const errorClosePollab = (): TFrameEvent => {
    return { ...errorEvent(), command: 'close' }
}

export const showResultEvent = (): TFrameEvent => {
    return { event: 'result', userInteraction: false }
}

/**
 * NOTE: Next events are temporary unused, please move up if some of them is in use.
 * Please remove this comment after all event are resolved.
 **/
export const userOpenNextQuestionEvent = (): TFrameEvent => {
    return { event: 'next', userInteraction: true }
}

export const userOpenPreviousQuestionEvent = (): TFrameEvent => {
    return { event: 'prev', userInteraction: true }
}
